export default "__VITE_ASSET__KZP6lV1z__";